export var Name = 'personal-product-list';
export var PersonalProductList = Name;
export var PersonalProductListAction;

(function (PersonalProductListAction) {
  PersonalProductListAction["Create"] = "create";
  PersonalProductListAction["Update"] = "update";
  PersonalProductListAction["Delete"] = "delete";
})(PersonalProductListAction || (PersonalProductListAction = {}));

export var PersonalProductListType;

(function (PersonalProductListType) {
  PersonalProductListType["Personal"] = "personal";
  PersonalProductListType["Private"] = "private";
})(PersonalProductListType || (PersonalProductListType = {}));